
import { Container, Button, Form, Alert } from 'react-bootstrap';
import { Sida, Rubrik, Stycke, ContentWrapper } from "./ContentStyles";
import React from 'react';
import useBackend, { SpinnerX } from '../services/useBackend_v2';
import Rules from './Rules';
import { Branding } from '../services/misc';

export default function Signup() {
    const { loading, resultVariant, resultVisible, resultText, Update, XCall } = useBackend('');

    async function handleSubmit(e) {
        e.preventDefault();
        const formData = new FormData(e.target), formDataObj = Object.fromEntries(formData.entries())
        //await Update({ SystemID: "NS", FormData: formDataObj }, 'POST', 0, '/backend/forms/signup');
        await XCall('/backend/forms/signup', 'POST', 3000, { SystemID: "NS", FormData: formDataObj });
    }

    return (
        <ContentWrapper>
            <Container>
                <Sida>
                    <Rubrik>Skapa konto</Rubrik>

                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3" controlId="formBasicEmail1" >
                            <Form.Control type="text" name="contact" placeholder="Kontaktperson" disabled={resultVariant === "success" ? true : false}/>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicEmail3">
                            <Form.Control type="email" name="Email" placeholder="Email" disabled={resultVariant === "success" ? true : false}/>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicEmail4">
                            <Form.Control type="text" name="company" placeholder="Företag" disabled={resultVariant === "success" ? true : false}/>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicEmail5">
                            <Form.Control type="text" name="orgnr" placeholder="Orgnr" disabled={resultVariant === "success" ? true : false}/>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicEmail6">
                            <Form.Control type="text" name="street01" placeholder="Gatuadress" disabled={resultVariant === "success" ? true : false}/>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicEmail7">
                            <Form.Control type="text" name="zip" placeholder="Postnr" disabled={resultVariant === "success" ? true : false}/>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicEmail8">
                            <Form.Control type="text" name="city" placeholder="Ort" disabled={resultVariant === "success" ? true : false}/>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicEmail22">
                            <Form.Control type="password" name="password" placeholder="Lösenord" disabled={resultVariant === "success" ? true : false}/>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicEmail33">
                            <Form.Control type="password" name="password_validate" placeholder="Upprepa lösenord" disabled={resultVariant === "success" ? true : false}/>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicEmail23" >
                            <Form.Check name="contractok" size="sm" type="checkbox" id="2" label="Jag har läst och förstått avtalet för vald tjänst." inline disabled={resultVariant === "success" ? true : false} /><Rules></Rules>
                        </Form.Group>

                        <Stycke hidden={!loading}>
                            <SpinnerX />
                        </Stycke>

                        <Alert show={resultVisible} variant={resultVariant} Style="font-size: 20px;">{resultText}</Alert>
                        <Button className="QmeButton" style={{ backgroundColor: Branding().ButtonColor }} variant="primary" type="submit" disabled={resultVariant === "success" ? true : false}>Skapa konto</Button>
                    </Form>
                </Sida>
            </Container>
        </ContentWrapper>
    );
};